import { useCallback, useState } from "react";
import { api } from "src/shared/setup/API/api";

interface ICurrentBalanceResponse {
  id_produtor: string;
  saldo: number;
  categoria: string | null;
  updated_at: string | null;
}

export const useCurrentBalanceProducer = () => {
  const [currentBalance, setCurrentBalance] = useState<number>(0);
  const [loadingCurrentBalance, setLoadingCurrentBalance] = useState(false);

  const handleGetCurrentBalance = useCallback(async (idTenant: string) => {
    if (!idTenant) return;

    setLoadingCurrentBalance(true);
    await api
      .post<ICurrentBalanceResponse>(`/contaCorrente/currentBalance/${idTenant}`)
      .then(({ data }) => {
        setCurrentBalance(Number(data?.saldo || 0));
      })
      .catch(() => {
        setCurrentBalance(0);
      })
      .finally(() => setLoadingCurrentBalance(false));
  }, []);

  return {
    currentBalance,
    loadingCurrentBalance,
    handleGetCurrentBalance,
  };
};
